"use strict";

var _Object$defineProperty = require("@babel/runtime-corejs3/core-js/object/define-property");
_Object$defineProperty(exports, "__esModule", {
  value: true
});
exports.getValuesWithNames = getValuesWithNames;
var _getValues = require("../get-values");
var _getInputsWithNames = require("../get-inputs-with-names");
function getValuesWithNames(formElement, inputStates, inputNames) {
  return (0, _getValues.getValues)(formElement, (0, _getInputsWithNames.getInputsWithNames)(inputStates, inputNames));
}